import React, {useEffect, useState} from 'react';
import {
  Grid, Button, Stack, Box, Chip,
  Paper, Typography,Alert,AlertTitle, IconButton
} from '@mui/material';

//import Box from '@mui/material/Box';
import { useSelector,useDispatch } from 'react-redux';
import {usePlayContext} from '../utils/PlayContext';

import { visitorsSyncLoaded,
  selectVisitorByFilter,
  selectVisitorIds,
  selectVisitorById,
  selectAllVisitors,
  selectVisitorStatus,
  selectVisitorLastFetched,
  refreshlVisitors,
   fetchAllVisitors } from '../store/visitorSlice';


import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';


import ViewProvider from '../utils/ViewContext'

import { useNavigate, useLocation, Outlet } from 'react-router-dom';


const VisitorPage = () => {

    const {
      setOp,
      status, setStatus, appTitle, setAppTitle, 
      errorMessage, setErrorMessage, errorTitle, setErrorTitle,
      setTenantLogo
    }=usePlayContext()


    const dispatch = useDispatch()
    const ids = useSelector(selectVisitorIds)
    const visitorDataLastFetched = useSelector(selectVisitorLastFetched)
    // const location = useLocation();
    // const myState = !!location.state?.state;

    
    const doFetchData = async (refresh=false)=>{
      
      console.log("doFetchData::refresh"+refresh)
      setStatus('processing')
      try
      {
         let respAllVisitors = await dispatch(fetchAllVisitors()).unwrap();
         
          setStatus('idle')
      }
      catch (ex)
      {
        console.error(ex)
        setStatus('error')
        setErrorMessage("Cannot retrieve Visitor info")
      } 
    }

    const five_minutes = 60*5*1000
    const one__hours = five_minutes*2
    
    useEffect(() =>{
      //setErrorMessage('')
      //setErrorTitle('')
      //if (visitorDataStatus!='succeeded')
      
      let tm=Date.now()
      //if (tm-visitorDataLastFetched>five_minutes)
        doFetchData( (tm-visitorDataLastFetched)>one__hours)
      }, [])
  
  
    
  return (
    <ViewProvider>
    <Box sx={{ p:0, width:'100%' }}>
       
      <Outlet/>       
      
      
    </Box>
    </ViewProvider>
  );
};

export default VisitorPage;
